import { createRef, h } from "preact";
import i18n from "../../i18n.js";

import Dropdown from "../Dropdown.jsx";
import DropdownInput from "../DropdownInput.jsx";
import { classNames } from "../../helpers.js";

export default function Proficiency({
  error,
  proficiencies,
  onClick,
  selectedProficiency,
}) {
  const ref = createRef();

  return (
    <Dropdown
      class="skill-chooser__dropdown-element"
      triggerClass={classNames(
        "skill-chooser__dropdown-input",
        error && "skill-chooser__dropdown-element--invalid"
      )}
      items={proficiencies}
      ref={ref}
      onClick={(event) => {
        ref.current.close();
        onClick(event);
      }}
    >
      <DropdownInput
        label={i18n.t("component.skill_chooser.proficiency")}
        iconAfter="keyboard_arrow_down"
      >
        {selectedProficiency}
      </DropdownInput>
    </Dropdown>
  );
}
